/**
 * Generates a Dealer Connection CKS Visit ID to be attached on lead
 * confirmations. The ID follows the format "YYMMDD-dc-nnnnnnnnnn",
 * where "nnnnnnnnnn" is a random 10 digit number.
 *
 * @param {string} cksCode The 2 letter CKS ID of the submitted form
 * @returns {string} The CKS Visit ID for a lead
 */
export default (cksCode) => {
	let cksId = cksCode;
	if (typeof cksId !== 'string' || cksId.length !== 2) {
		cksId = 'dc';
	}

	return `${new Date()
		.toISOString()
		.substring(2, 10)
		.replace(/-/g, '')}-${cksId}-${Math.random()
		.toString()
		.substring(2, 12)}`;
};
